import { Component, OnInit } from '@angular/core';
import { SlideTypeLinesService } from '@app/services/slide-type-lines.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slide-type-form',
  templateUrl: './slide-type-form.component.html',
  styleUrl: './slide-type-form.component.scss'
})

export class SlideTypeFormComponent implements OnInit {

  STshortcode = '';
  STName = '';
  STRemarks = '';
  STlayoutSC = '';
  slideTypes: any[] = [];
  selectedSlideType: string = '';
  customLayouts: any[] = [];
  selectedCustomLayout: string = '';
  useExistingLines = false;
  SlideTypeLinesArr: any[] = [];
  isEditMode = false;
  finalSlideTypeLinesArr: any[] = [];
  slideLayoutShortcode = '';

  constructor(private SlideTypeService: SlideTypeLinesService, private router: Router,) { }

  ngOnInit() {
    this.SlideTypeService.getslideTypeList().subscribe(data => this.slideTypes = data);
    this.SlideTypeService.getCustomLayoutsListforPick().subscribe(data => { this.customLayouts = data; });
    const navigation = history.state;
    if (navigation && navigation.editSlideType) {
      const editSlideType = navigation.editSlideType;
      this.isEditMode = true;
      this.STshortcode = editSlideType.slideTypeShortcode;
      this.STName = editSlideType.slideTypeName;
      this.STRemarks = editSlideType.slidetypeRemarks;
      this.STlayoutSC = editSlideType.slideLayoutShortcode;
      this.selectedCustomLayout = editSlideType.selectedCustomLayout;
      this.SlideTypeLinesArr = [];
      this.useExistingLines = true;
    }
  }

  saveSlideType() {
    if (this.useExistingLines && !this.isEditMode && this.selectedSlideType) {
      this.SlideTypeService.getslideTypeLinesByShortCode(this.selectedSlideType).subscribe({
        next: (data) => {
          this.finalSlideTypeLinesArr = this.cloneLinesForNewSlideType(data);
          this.persistSlideType();
        },
        error: () => {
          this.finalSlideTypeLinesArr = [];
          this.persistSlideType();
        },
      });
      return;
    }

    if (this.useExistingLines && this.isEditMode) {
      this.finalSlideTypeLinesArr = Array.isArray(this.SlideTypeLinesArr) ? this.SlideTypeLinesArr : [];
    } else {
      this.finalSlideTypeLinesArr = [];
    }
    this.persistSlideType();
  }

  private cloneLinesForNewSlideType(lines: unknown): any[] {
    if (!Array.isArray(lines)) return [];
    return lines.map((line) => ({
      ...line,
      slideTypeShortcode: this.STshortcode,
    }));
  }

  private persistSlideType(): void {
    const newSlideType = {
      slideTypeShortcode: this.STshortcode,
      slideTypeName: this.STName,
      slidetypeRemarks: this.STRemarks,
      slideLayoutShortcode: this.selectedCustomLayout,
      details: Array.isArray(this.finalSlideTypeLinesArr) ? this.finalSlideTypeLinesArr : [],
    };
    this.SlideTypeService.saveslideType(newSlideType).subscribe(() => {
      this.router.navigate(['/designer/slide-type-list']);
    });
  }
}
